import {useBasCampaign} from '../../../features/AboutYouLogo/hooks/useBasCampaign';

// This hook is used to compute the tracking index position of each component into the BrowsePage
export const useSectionIndex = () => {
  const basCampaign = useBasCampaign();
  const isBasCampaignDisplayed = Boolean(basCampaign);

  let currentSectionIndex = 0;

  return {
    basBannerSectionIndex: isBasCampaignDisplayed
      ? ++currentSectionIndex
      : undefined,
    cardsSliderAmbientSectionIndex: ++currentSectionIndex,
    uspsSectionIndex: ++currentSectionIndex,
    categoryTilesSectionIndex: ++currentSectionIndex,
  };
};
